import { Navigate } from "react-router-dom";
import { isAuthenticated, isAdmin } from "../utils/session";
import ProtectedRoute from "./ProtectedRoute";

function ProtectedAdminRoute({ children }) {

  // Rejects a missing, malformed or expired (>7 days) token and clears it.
  if (!isAuthenticated()) {
    return <Navigate to="/" replace />;
  }

  if (!isAdmin()) {
    return <Navigate to="/home" replace />;
  }

  // Same server confirmation every protected page gets.
  return <ProtectedRoute>{children}</ProtectedRoute>;
}

export default ProtectedAdminRoute;
